<div class="canded-service-dialog">
  <div class="ui-g p-0">
    <!-- Start Canned Service Header -->
    <div class="ui-g-12 dialog-header flex-start-center p-2">
      <div class="service-header flex-between-center width-100p" [ngClass]="{ 'pb-2': this.validate?.title }">
        <div class="width-100p flex-start-center">
          <div class="width-30 flex-center-center font-16">
            <i class="fal fa-ballot-check"></i>
          </div>

          <div class="service-title-group">
            <app-input name="serviceTitle" placeholder="Enter canned service name" maxlength="50"
              *ngIf="!companyLocalization" [theme]="!service?.title || focus?.title ? 'secondary' : 'light'"
              [isInvalid]="errors?.title" [value]="service.title" [autoFocus]="true"
              (appChange)="handleChange('title', $event)" (appFocus)="handleFocus('title')"
              (appBlur)="handleBlur('title')"></app-input>
            <p class="canned-service-heading" *ngIf="companyLocalization">Canned Service Details</p>
          </div>
        </div>
        <i class="fal fa-times dialog-close mr-2" (click)="close()"></i>
      </div>
    </div>
    <!-- End Canned Service Header -->

    <p-tabView class="tab-panel-underline tab-panel-estimates tab-panel-default" (onChange)="selectedTab = $event">
      <p-tabPanel [selected]="selectedTab === 0">
        <ng-template pTemplate="header"> Basic info </ng-template>
        <ng-template pTemplate="content">
          <!-- Start Canned Service Body -->
          <div class="ui-g-12 dialog-body canned-service-dialog-body p-20p" cdkScrollable>

            <div *ngIf="companyLocalization">
              <div class="ui-g-12 p-0 mt-2 ">
                <p class="mb-0 font-600">Basic info</p>
              </div>
              <div class="ui-g-12 d-flex" [ngClass]="{'flex-row-reverse': currentLang === 'fr'}">
                <div class=" ui-lg-6 ui-g-6 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="fal fa-ballot-check"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2">
                    <app-input id="labor-title" type="text"
                      placeholder="Canned service name (EN){{ currentLang === 'en'? '*' : '' }}"
                      styleClassInput="width-100p" [maxLength]="100" [fontSize]="14" [value]="service?.title"
                      [errorMessage]="errors?.title" [isInvalid]="errors?.title" (appFocus)="handleFocus('title')"
                      (appBlur)="handleBlur('title')" (appChange)="handleChange('title', $event); updateSubmitButtonId()">
                    </app-input>
                  </div>
                </div>
                <div class=" ui-lg-6 ui-g-6 p-0 flex-start-center">
                  <div class="icon flex-center-start">
                    <i class="fal fa-ballot-check"></i>
                  </div>

                  <div class="width-100p pl-1 pr-2">
                    <app-input id="labor-title" type="text"
                      placeholder="Canned service name (FR){{ currentLang === 'fr'? '*' : '' }}"
                      styleClassInput="width-100p" [maxLength]="100" [fontSize]="14" [value]="service?.titleFR"
                      [isInvalid]="errors?.titleFR" (appFocus)="handleFocus('titleFR')" [errorMessage]="errors?.titleFR"
                      (appBlur)="handleBlur('titleFR')" (appChange)="handleChange('titleFR', $event); updateSubmitButtonId()">
                    </app-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="ui-g-12 p-0 flex-start-center" [ngClass]="{'mt-3':companyLocalization}">
              <div class="ui-g-4 p-0">
                <app-auto-complete placeholder="Select category" field="name" scrollHeight="198px" theme="border"
                  editableItemIdKey="_id" editFieldLabel="Create Category" [hasEditableField]="true"
                  [isShowError]="isShowError" [hasFutureSelectionField]="false" [closeOnSelection]="true"
                  [isDropdownIconVisible]="true" [hasStaticUnassignedFiled]="false" [suggestions]="categoryResults"
                  [listItemFontSize]="14" [fontSize]="12" [value]="service.category?.name || ''"
                  (appFocus)="showSuggestions('tags')" (appBlur)="blurInput('category')"
                  (appUpdateItem)="onUpdateItem($event, config?.tags?.cannedService)"
                  (appSelect)="onAutoCompleteSelect($event, 'tags')" (appSave)="saveCategory($event)"
                  (appChange)="handleChangeCategory(config?.tags?.cannedService, $event)"
                  (appCompletedMethod)="searchSuggestionCategory($event, 'tags')"
                  (appClear)="onClearSuggestion('tags')">
                  <ng-template let-item let-editItem="editItem" appTemplate="item">
                    <div class="tag-item flex-between-center">
                      <div>
                        <span>{{ item?.name }}</span>
                      </div>
                      <div class="tag-item-action flex-end-center">
                        <i class="fas fa-pencil p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                          (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return : editItem(item)"></i>
                        <i class="fa fa-trash p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                          (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return  : deleteCategoryDialog(item)"></i>
                      </div>
                    </div>
                  </ng-template>
                </app-auto-complete>
              </div>

              <div class="p-0 pl-2" [hidden]="isLoading">
                <app-switch-pill position="end" [fontSize]="14" [isActive]="service.status"
                  [label]="service.status ? 'Active' : 'Inactive'" (appChange)="handleChange('status', $event)">
                </app-switch-pill>
              </div>

              <div class="d-flex" *ngIf="isQTQAddOnEnable" [hidden]="isLoading">
                <div class="p-0 pl-3">
                  <app-switch-pill position="end" [fontSize]="14" [isActive]="service.qtqAddOn"
                    label="Tire quote add-on" (appChange)="handleChange('qtqAddOn', $event)">
                  </app-switch-pill>
                </div>

                <div class="pl-3" style="padding-top: 2px;" *ngIf="service.qtqAddOn">
                  <app-checkbox label="Set as default add-on" [isChecked]="service.qtqDefault"
                    [disabled]="qtqDefaultDisabled" (appChange)="handleChange('qtqDefault', $event)"> </app-checkbox>
                </div>

                <span *ngIf="service.qtqAddOn" class="pl-3 align-self-center" tooltipPosition="top"
                  pTooltip="This package will be the default for calculating out-the-door tire prices and adding magic services for tire sales"
                  tooltipStyleClass="ticket-tooltip modifier canned-service">
                  <i class="far fa-info-circle"></i>
                </span>
              </div>
            </div>

            <div class="ui-g-12 p-0 mt-2">
              <div class="table">
                <div class="table-header flex-start-center add-on-enabled">
                  <ng-container *ngIf="service.qtqAddOn && isQTQAddOnEnable">
                    <div class="table-heading add-on font-600 flex-start-center">
                      Default add-on
                    </div>

                    <div class="table-heading adj-qty font-600 flex-start-center">
                      Adjust with tire qty
                    </div>
                  </ng-container>

                  <div class="table-heading type font-600 flex-start-center">
                    Type
                  </div>

                  <div class="table-heading name font-600 pl-8p flex-start-center">
                    Name
                  </div>

                  <div class="table-heading description font-600 pl-8p flex-start-center">
                    Description
                  </div>

                  <div class="table-heading taxable font-600 pl-8p flex-start-center">
                    Taxable
                  </div>

                  <div class="table-heading price font-600 flex-start-center">
                    Price
                  </div>

                  <div class="table-heading quantity font-600 flex-start-center">
                    Qty/Hrs
                  </div>

                  <div class="table-heading subtotal font-600 flex-start-center">
                    Subtotal
                  </div>

                  <div class="table-heading delete"></div>
                </div>

                <div class="service-list" cdkDropList [cdkDropListData]="service.items"
                  (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="dragDisabled" [cdkDropListAutoScrollStep]=5>
                  <div class="table-body service-wrapper" cdkDrag
                    *ngFor="let item of service.items; let rowIndex = index"
                    cdkDragBoundary=".canned-service-dialog-body">
                    <div class="Rectangle-147" *ngIf="item.title !== '' || item.type !== '' "
                      (mousedown)="dragDisabled = false;">
                      <img src="assets/img/grab-handle-icon.svg" class="grab-handle-icon">
                    </div>

                    <app-canned-service-item [isLoading]="isLoading" [isOtherTaxable]="isOtherTaxable"
                      [itemData]="item?.itemData" [isSubletTaxable]="isSubletTaxable" [serviceItems]="service.items"
                      [companyLocalization]="companyLocalization" [currentLang]="currentLang" [serviceInspection]="service.inspection"
                      [serviceItemCount]="service.items?.length" [errors]="serviceErrors[rowIndex] || {}"
                      [isEditMode]="isEditMode" [serviceItem]="item" [index]="rowIndex" 
                      [partsLookupDropDownList]="partsLookupDropDownList" [isTireStorage2Enabled]="isTireStorage2Enabled"
                      [isLast]="service.items.length - 1 === rowIndex" (addServiceItem)="addItem()"
                      [qtqAddOn]="service.qtqAddOn" [isQTQAddOnEnable]="isQTQAddOnEnable"
                      [selectAllItems]="service.selectAllItems" (itemDelete)="itemDelete($event)"
                      (calculateTotal)="calculateTotal($event)" (tireStorageInspection)="onSelectInspection($event)"
                      (calculateTotalQtqAddon)="calculateTotalQtqAddon($event)" (appChange)="updateSubmitButtonId()"
                      (fieldChange)="updateSubmitButtonId()"
                       ></app-canned-service-item>

                    <div class="sub-service-item disable-sub-item" [hidden]="!item?.isExpanded">
                      <app-canned-service-item *ngFor="let subItem of item?.subItems" [serviceItem]="subItem"
                        [index]="rowIndex" [isEditMode]="false" [isSubItem]="true">
                      </app-canned-service-item>
                    </div>
                  </div>
                </div>

                <div class="ui-g-12 p-0 service-total">
                  <div class="ui-g-12 p-0 total flex-between-center">
                    <p class="table-heading total-label flex-start-center type font-bold font-12 m-0">
                      Total
                    </p>

                    <p class="total-price m-0 flex-start-center font-bold font-12 m-0">
                      {{service.serviceTotal.total | currency: usd}}
                    </p>
                  </div>
                </div>

                <div class="ui-g-12 p-0 canned-service-inspection">
                  <div class="canned-service-ins-header flex-between-center">
                    <p class="m-0">Inspection</p>
                    <div class="canned-service-ins-line"></div>
                  </div>

                  <div class="service-empty-inspection">
                    <div *ngIf="!serviceInspLoading && !isInspectionSearchVisible && !service?.inspection?.inspectionId"
                      class="empty-service-inspection flex-center-center">
                      <button class="add-inspection btn btn-border pointer btn-submit mr-1"
                        (click)="isInspectionSearchVisible = true">
                        Add inspection
                      </button>
                    </div>

                    <div *ngIf="serviceInspLoading" class="empty-service-inspection flex-center-center">
                      <span class="pr-2">Loading</span>
                      <div class="fal fa-spinner rotate"></div>
                    </div>
                  </div>

                  <div class="mt-2"
                    *ngIf="!serviceInspLoading && isInspectionSearchVisible && !service?.inspection?.inspectionId">
                    <app-auto-complete placeholder="Search inspections" styleClassInput="p-0" scrollHeight="270px"
                      leftIcon="fal fa-search pr-1" styleClassInputWrapper="p-6p" theme="border" field="title"
                      [autoFocus]="true" [id]="'ac-canned'" [listId]="'ac-canned-list'"
                      [isLoading]="isSearchingInspection" [suggestions]="cannedInspectionSuggestion"
                      [closeOnSelection]="true" [hasStaticUnassignedFiled]="false" [hasEditableField]="false"
                      (appSelect)="onSelectInspection($event)" (appCompletedMethod)="onSearchInspection($event)"
                      (appClear)="onSearchInspection('')">
                      <ng-template let-item appTemplate="item">
                        <div class="flex-between-center canned-service-item"
                          [ngClass]="{ 'inactive-service': !item?.status }">
                          <div class="flex-start-center flex-row">
                            <i class="fal fa-list-ul font-15 pr-2"></i>

                            <span class="flex-center-start flex-column">
                              <span>{{ item?.title }}</span>
                              <span class="font-10 text-left">
                                {{ item?.categoryCount }} Categories,
                                {{ item?.itemCount }} items
                              </span>
                            </span>
                          </div>
                        </div>
                      </ng-template>
                    </app-auto-complete>
                  </div>

                  <!-- Start Service Inspection -->
                  <div class="mt-2" *ngIf="
                !serviceInspLoading && service?.inspection?.inspectionId
              ">
                    <div class="service-inspection flex-between-center pointer" (click)="handleOpenInspectionDialog()">
                      <div class="service-inspection-left flex-start-center">
                        <i class="fal fa-ballot-check font-gray-45"></i>

                        <div class="service-inspection-title flex-between-center">
                          <p class="font-600 m-0 ml-2">
                            {{ service?.inspection?.inspectionId?.title }}
                          </p>
                          <div class="h-line ml-1 mr-1" [hidden]="service?.inspection?.isTireStorageInspection"></div>
                          <p class="m-0 font-4c" [hidden]="service?.inspection?.isTireStorageInspection">{{ categoryItemText }}</p>
                        </div>
                      </div>

                      <div class="service-inspection-right flex-end-center" [hidden]="service?.inspection?.isTireStorageInspection">
                        <div class="ml-4 mr-2 p-1 pointer" (click)="handleConfirmInspectionDelete()">
                          <i class="fas fa-trash font-gray-35"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Service Inspection -->
                </div>
              </div>
            </div>
          </div>
          <!-- End Canned Service Body -->

          <!-- Start Canned Service Footer -->
          <div class="ui-g-12 text-right dialog-footer canned-footer">
            <button class="btn btn-border pointer btn-submit mr-1" (click)="close()">
              Cancel
            </button>
            <button #submitBtn id="submit-btn" class="btn btn-primary btn-submit" [disabled]="!service?.items?.length || isProcessing"
              (click)="onSubmit()">
              <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
              <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
            </button>
          </div>
          <!-- Start Canned Service Footer -->
        </ng-template></p-tabPanel>

      <p-tabPanel [selected]="selectedTab === 1">
        <ng-template pTemplate="header"> Activity logs </ng-template>
        <ng-template pTemplate="content">
          <div class="activity-logs">
            <div class="catalog-activity-wrapper">
              <!-- Activity logs -->
              <div *ngIf="activityLogs?.length" class="catalog-activity-inner-wrapper">
                <div *ngFor="let activityLog of activityLogs">
                  <app-catalog-activity-logs [activityLog]="activityLog"></app-catalog-activity-logs>
                </div>
              </div>

              <div *ngIf="!activityLogs?.length" class="catalog-activity-inner-wrapper no-activity-logs p-3">
                <p>There are no activity logs.</p>
              </div>
            </div>
          </div>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
